import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Store } from '../../../../typings'

export const invalidTokenError = {
  heading: (
    <FormattedMessage
      id="gympass_error_invalid_token_heading"
      defaultMessage="Error: Invalid token"
    />
  ),
  text: (
    <p className="leading-body">
      <FormattedMessage
        id="gympass_error_invalid_token_text"
        defaultMessage="We’re sorry, the token is either invalid or outdated. Please go back to Wellhub and try again."
      />
    </p>
  ),
}

export const unhandledError = {
  heading: 'Error: Unhandled error',
  text: (
    <p className="leading-body">
      <FormattedMessage
        id="reset_error"
        defaultMessage="We’re sorry, something on our end didn't go as planned. Please try again soon or contact us for further assistance."
      />
    </p>
  ),
}

export const noTokenError = {
  heading: (
    <FormattedMessage
      id="gympass_error_no_token_heading"
      defaultMessage="Error: No token"
    />
  ),
  text: (
    <p className="leading-body">
      <FormattedMessage
        id="gympass_error_no_token_text"
        defaultMessage="We’re sorry, there seems to be something wrong with the page address. Please go back to Wellhub and try again."
      />
    </p>
  ),
}

type AlreadyPremiumTextProps = {
  store: Store
}

const AlreadyPremiumText = ({ store: storeName }: AlreadyPremiumTextProps) => {
  let store

  switch (storeName) {
    case 'itunes':
      store = 'iTunes'
      break
    case 'playstore':
      store = 'Google Play'
      break
    case 'samsung':
      store = 'Galaxy Store'
      break
    default:
      store = <Link to="/account">lifesum.com</Link>
  }

  return (
    <div className="s-text">
      <p>
        <FormattedMessage
          id="gympass_error_already_premium_text_1"
          defaultMessage="This account already has an active Lifesum Premium subscription via {store}. In order to claim Lifesum Premium via Wellhub, you first need to cancel your subscription via {store} and wait for it to expire."
          values={{ store }}
        />
      </p>
      <p>
        <a
          href="https://lifesum.helpshift.com/a/lifesum---healthier-eating-better-living/?s=lifesum-premium&amp;f=how-can-i-cancel-my-lifesum-premium-membership-subscription-avoid-a-renewal"
          className={`
            inline-block rounded-8 border-1 border-Border
            bg-Bg px-24 pb-6 pt-8
            font-demibold shadow-elevated
          `}
        >
          <FormattedMessage
            id="gympass_error_already_premium_link"
            defaultMessage="How to cancel your subscription"
          />
        </a>
      </p>
      <p>
        <FormattedMessage
          id="gympass_error_already_premium_text_2"
          defaultMessage="Once your subscription via {store} has expired, please return to Wellhub and try again. We are sorry for the inconvenience."
          values={{ store }}
        />
      </p>
    </div>
  )
}

export const alreadyPremiumError = (store: Store) => ({
  heading: (
    <FormattedMessage
      id="gympass_error_already_premium_heading"
      defaultMessage="Error: Existing Lifesum Premium subscription"
    />
  ),
  text: <AlreadyPremiumText store={store} />,
})
